import styled from "styled-components"
import { device } from "breakpoints"

export const ImgTextCustomContainer = styled.div`
  width: 100%;
  background: ${props => props.theme.blue};
  display: flex;
  flex-direction: column;
  padding: 30px;
  max-width: 1160px;
  position: relative;
  margin-top: 40px;
  margin-bottom: 40px;

  @media ${device.tablet} {
    flex-direction: row;
    width: 100%;
    margin: 0 auto;
    align-items: center;
    padding-bottom: 0;
    margin-top: 40px;
    margin-bottom: 70px;
  }
  @media ${device.desktop} {
    padding: 40px;
    padding-bottom: 0;
    margin-top: 70px;

    margin-bottom: 110px;
  }

  :hover {
    svg {
      transform: scale(1.12);
    }
  }
`
export const ImgWrapper = styled.div`
  margin-bottom: 33px;
  position: relative;
  @media ${device.tablet} {
    flex-direction: row;
    width: 50%;
    margin-bottom: -30px;
    min-height: 360px;
  }

  @media ${device.desktop} {
    margin-bottom: -40px;
  }

  @media ${device.large} {
    width: 550px;
  }
`

export const TextWrapper = styled.div`
  @media ${device.tablet} {
    width: 50%;
    padding-left: 45px;
    padding-right: 20px;
    padding-bottom: 20px;
  }

  @media ${device.desktop} {
    padding-left: 80px;
    padding-right: 50px;
    padding-bottom: 30px;
  }
  h3 {
    color: ${props => props.theme.green};
    font-size: 28px;
    margin-bottom: 20px;
    line-height: 115%;
    width: 100%;

    @media ${device.desktop} {
      font-size: 36px;
      margin-bottom: 25px;
    }

    a {
      color: inherit;
      width: 100%;

      :before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
        width: 100%;
        height: 100%;
      }
    }
  }

  p {
    width: 100%;

    color: white;
    font-size: 16px;
    margin-bottom: 30px;
    @media ${device.desktop} {
      font-size: 18px;
      margin-bottom: 30px;
      letter-spacing: 0.5px;
    }
  }

  svg {
    transform: scale(1);
    transition: 420ms;
    height: 40px;
    width: 40px;
  }
`
